import { render, staticRenderFns } from "./event-card-footer.vue?vue&type=template&id=57c6814e&"
import script from "./event-card-footer.vue?vue&type=script&lang=js&"
export * from "./event-card-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c6814e')) {
      api.createRecord('57c6814e', component.options)
    } else {
      api.reload('57c6814e', component.options)
    }
    module.hot.accept("./event-card-footer.vue?vue&type=template&id=57c6814e&", function () {
      api.rerender('57c6814e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/events/event-card-footer/event-card-footer.vue"
export default component.exports